module.exports = __webpack_public_path__ + "img/ef14444.jpg";